import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { podcastApiResponse } from 'features/podcast/services/podcastApi';

const initialState: podcastApiResponse = {
  success: false,
  message: '',
  data: { dialogues: [] },
};

const podcastResponseSlice = createSlice({
  name: 'podcastResponse',
  initialState,
  reducers: {
    setResponse: (state, action: PayloadAction<podcastApiResponse>) => {
      state.success = action.payload.success;
      state.message = action.payload.message;
      state.data = action.payload.data;
    },
    deleteDialogue: (state, action: PayloadAction<number>) => {
      const index = action.payload;

      // Using slice to exclude the item at the specified index
      state.data.dialogues = [
        ...state.data.dialogues.slice(0, index), // Items before the index
        ...state.data.dialogues.slice(index + 1), // Items after the index
      ];
    },
    updateDialogue: (
      state,
      action: PayloadAction<{ index: number; text: string }>
    ) => {
      const { index, text } = action.payload;

      if (index >= 0 && index < state.data.dialogues.length) {
        state.data.dialogues[index].dialogue = text;
      }
    },
    regenDialogue: (
      state,
      action: PayloadAction<{
        index: number;
        text: string;
        preview_url: string;
        presigned_preview_url : string
      }>
    ) => {
      const { index, text, preview_url, presigned_preview_url } = action.payload;

      if (index >= 0 && index < state.data.dialogues.length) {
        state.data.dialogues[index].dialogue = text;
        state.data.dialogues[index].preview_url = preview_url;
        state.data.dialogues[index].presigned_preview_url = presigned_preview_url;
      }
    },
    discardData: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setResponse,
  deleteDialogue,
  updateDialogue,
  regenDialogue,
  discardData,
} = podcastResponseSlice.actions;
export default podcastResponseSlice.reducer;
